var _rect, _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4, _circle5, _polygon, _polygon2, _path5, _path6, _g, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#190A4E"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFB02E",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E09920",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00D9FF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0099CC",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFB02E",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFB02E",
      stopOpacity: 0.2
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 100 Q250 50 350 100 Q450 150 420 280 Q400 380 300 400 Q200 420 120 340 Q50 260 150 100 Z",
    fill: "url(#grad1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450 200 Q520 280 500 400 Q480 520 350 550 Q220 580 200 480 Q180 380 280 320 Q380 260 450 200 Z",
    fill: "url(#grad2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 250,
    r: 80,
    fill: "url(#radial1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 350,
    r: 60,
    fill: "#00D9FF",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 500 Q200 450 300 480 Q400 510 500 470",
    stroke: "#FFB02E",
    strokeWidth: 15,
    fill: "none",
    opacity: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 350 Q180 320 280 360 Q380 400 480 350",
    stroke: "#00D9FF",
    strokeWidth: 12,
    fill: "none",
    opacity: 0.4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 150,
    r: 25,
    fill: "#FFFFFF",
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 450,
    r: 30,
    fill: "#FFB02E",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 120,
    r: 20,
    fill: "#00D9FF",
    opacity: 0.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "480,480 520,550 440,550",
    fill: "#FFB02E",
    opacity: 0.6
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "100,80 140,120 60,120",
    fill: "#00D9FF",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 200 Q100 180 150 200 Q200 220 250 200 Q300 180 350 200",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 550 Q300 530 350 550 Q400 570 450 550 Q500 530 550 550",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 250,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 280,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 480,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 530,
    r: 3
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 50,
    x2: 500,
    y2: 150,
    stroke: "#FFB02E",
    strokeWidth: 3,
    opacity: 0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 550,
    x2: 120,
    y2: 500,
    stroke: "#00D9FF",
    strokeWidth: 3,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractArt);
export default __webpack_public_path__ + "static/media/abstract-art.c00331825ec7ca0ef7347ecceac74a7b.svg";
export { ForwardRef as ReactComponent };